import type { LearnPracticalContent } from "../practicalContent.js";

export const familyPreparednessContent: LearnPracticalContent = {
  th: {
    notice: [
      "เหตุฉุกเฉินอาจทำให้คนในบ้านแยกกัน โทรศัพท์ใช้ไม่ได้ หรือกลับบ้านไม่ได้",
      "เด็ก ผู้สูงอายุ ผู้พิการ ผู้ใช้ยา และสัตว์เลี้ยงอาจต้องการแผนเฉพาะ",
      "แผนที่ทุกคนไม่รู้หรือข้อมูลติดต่อเก่าอาจใช้ไม่ได้เมื่อเกิดเหตุจริง",
      "งาน โรงเรียน การเดินทาง และการดูแลผู้พึ่งพาอาจทำให้คนในบ้านอยู่คนละที่ จึงควรวางแผนสำหรับช่วงกลางวันไม่ใช่เฉพาะเวลาที่อยู่บ้าน",
    ],
    prepare: [
      "บันทึกผู้ติดต่อ จุดนัดพบ ยาประจำ ข้อมูลสัตว์เลี้ยง และสิ่งจำเป็นของแต่ละคน",
      "ส่งออกข้อมูลสำรองแบบเข้ารหัสและเก็บรหัสผ่านแยกจากอุปกรณ์",
      "กำหนดจุดนัดพบในบ้าน ใกล้บ้าน และนอกย่าน พร้อมผู้ติดต่อที่อยู่นอกพื้นที่",
      "ทำสำเนาข้อมูลสำคัญที่พกได้ และกำหนดว่าใครรับผิดชอบหยิบยา เอกสาร หรือดูแลสัตว์เลี้ยง โดยปรับตามความสามารถจริงของแต่ละคน",
    ],
    during: [
      "ใช้แผนที่ตกลงไว้และปรับตามประกาศของพื้นที่",
      "ส่งข้อความสั้นเมื่อเครือข่ายไม่สะดวก และรักษาแบตเตอรี่ไว้",
      "บอกสถานะ ตำแหน่ง และจุดนัดพบอย่างสั้น ๆ แล้วรอ ไม่โทรซ้ำถี่จนเครือข่ายแน่นขึ้น",
      "ใช้ข้อมูลล่าสุดที่ยืนยันจากโรงเรียน นายจ้าง ผู้ดูแลอาคาร หรือหน่วยงานพื้นที่ก่อนเปลี่ยนแผนเดินทางหรือจุดนัดพบ",
    ],
    avoid: [
      "อย่าเก็บข้อมูลสำคัญไว้ในโทรศัพท์เครื่องเดียวโดยไม่มีสำเนา",
      "อย่าใส่ข้อมูลลับในส่วนที่ไม่เข้ารหัสของแผน",
      "อย่านัดพบในพื้นที่เสี่ยง และอย่าฝืนเดินทางหากประกาศท้องถิ่นให้หลบอยู่กับที่",
      "อย่าเผยแพร่รหัสผ่าน รายละเอียดการแพทย์ หรือที่อยู่ของสมาชิกในแชตสาธารณะ แม้กำลังตามหากัน",
    ],
    help: [
      "ติดต่อหน่วยงานตามชนิดเหตุและพื้นที่จากไดเรกทอรีเบอร์สำคัญ",
      "หากสมาชิกหาย ให้แจ้งข้อมูลล่าสุดที่ยืนยันได้แก่เจ้าหน้าที่",
      "ขอความช่วยเหลือล่วงหน้าหากคนในบ้านต้องใช้ไฟฟ้ากับอุปกรณ์แพทย์ ต้องเคลื่อนย้ายด้วยความช่วยเหลือ หรือไม่มีพาหนะ",
      "เมื่อข้อมูลสมาชิกหรือความต้องการเปลี่ยน เช่น ย้ายที่อยู่ โรงเรียนใหม่ หรือเริ่มใช้ยา ให้ทบทวนแผนแทนการรอให้เกิดเหตุ",
    ],
    example:
      "ลูกกลับบ้านไม่ได้เพราะถนนปิด: ใช้จุดนัดพบสำรองและผู้ติดต่อที่ตกลงไว้ ตรวจประกาศพื้นที่ และบอกกันสั้น ๆ ว่าตอนนี้อยู่ที่ไหนโดยไม่ส่งข้อมูลส่วนตัวในช่องสาธารณะ",
    emergencyKit: {
      intro:
        "เริ่มจากของที่บ้านใช้ได้จริง ค่อย ๆ เติมระหว่างการซื้อของตามปกติ ไม่จำเป็นต้องซื้อทุกอย่างพร้อมกันหรือกักตุนเกินความจำเป็น",
      target:
        "ตั้งเป้าพื้นฐานสำหรับการดูแลคนในบ้านช่วงแรก 3 วันตามบริบทพื้นที่และความต้องการจริง น้ำดื่ม 3 ลิตรต่อคนต่อวันเป็นตัวอย่างคำแนะนำของแคมเปญรัฐบาลสหราชอาณาจักรสำหรับการดื่มเท่านั้น; การทำอาหาร สุขอนามัย อากาศร้อน เด็ก และภาวะสุขภาพอาจต้องมากหรือน้อยต่างกัน",
      items: [
        {
          title: "น้ำดื่มและอาหารเก็บได้นาน",
          text: "เก็บน้ำดื่มบรรจุขวดและอาหารที่กินได้จริงโดยไม่ต้องแช่เย็นหรือปรุงซับซ้อน เช่น อาหารกระป๋อง อาหารแห้ง ข้าว หรือของว่าง พร้อมที่เปิดกระป๋องถ้าจำเป็น",
        },
        {
          title: "แสงสว่างและพลังงานสำรอง",
          text: "มีไฟฉาย ถ่านสำรอง พาวเวอร์แบงก์ และสายชาร์จที่เข้ากับอุปกรณ์ของบ้าน ไฟฉายปลอดภัยกว่าเทียนเมื่อไฟดับ",
        },
        {
          title: "การสื่อสารและข้อมูล",
          text: "จดเบอร์สำคัญ จุดนัดพบ และความถี่วิทยุที่ใช้ติดตามข่าวไว้บนกระดาษ มีวิทยุใช้ถ่านหรือหมุนมือ นกหวีด และแผนที่เมื่อเหมาะกับพื้นที่",
        },
        {
          title: "สุขอนามัย",
          text: "เตรียมกระดาษชำระ ทิชชูเปียก เจลล้างมือ หน้ากาก ถุงขยะ และของใช้ห้องน้ำตามที่คนในบ้านใช้จริง โดยไม่ทิ้งสุขอนามัยเพียงเพราะอยู่ในภาวะฉุกเฉิน",
        },
        {
          title: "ยาและปฐมพยาบาล",
          text: "เก็บยาประจำตัว รายการยา ข้อมูลแพ้ยา และชุดปฐมพยาบาลที่พร้อมใช้ ตรวจฉลาก วันหมดอายุ และวิธีเก็บยาเป็นระยะ",
        },
        {
          title: "เสื้อผ้าและของใช้ดำรงชีพ",
          text: "เลือกผ้าห่ม เสื้อกันฝน รองเท้าเดินได้จริง และของใช้ทำอาหารตามความเสี่ยงของบ้าน อย่าพึ่งอุปกรณ์ที่ต้องใช้เชื้อเพลิงในที่อับอากาศ",
        },
        {
          title: "กระเป๋าหยิบออกได้ทันที",
          text: "แยกของจำเป็นที่พกออกจากบ้านได้ เช่น สำเนาเอกสาร กุญแจ เงินสดตามความเหมาะสม น้ำ อาหาร ยา และข้อมูลติดต่อ โดยเก็บให้สมาชิกที่รับผิดชอบหยิบถึง",
        },
        {
          title: "ความต้องการเฉพาะของคนและสัตว์เลี้ยง",
          text: "เติมนม อาหาร ผ้าอ้อม อุปกรณ์ช่วยเหลือ ยา หรืออาหารสัตว์ตามสมาชิกจริงของบ้าน และตกลงว่าใครดูแลสิ่งใดหากต้องออกจากบ้าน",
        },
      ],
      rotation:
        "ตั้งเตือนตรวจอย่างน้อยทุก 6 เดือน ใช้ของที่ใกล้หมดอายุก่อน แล้วซื้อเติมกลับเข้าไปตามปกติ การเตรียมพร้อมช่วยให้ดูแลกันได้ในช่วงแรก และไม่ควรทำให้คนอื่นขาดของจำเป็น",
    },
    serviceDisruption: {
      intro:
        "หากเกิดความขัดแย้งรุนแรงหรือสงคราม ผลกระทบต่อพลเรือนอาจรวมถึงไฟฟ้า น้ำ การเดินทาง หรือเครือข่ายสื่อสารสะดุด แผนนี้ช่วยให้ครอบครัวรอข้อมูลและความช่วยเหลืออย่างเป็นระบบ ไม่ใช่การคาดการณ์ว่าเหตุใดจะเกิดขึ้น",
      actions: [
        {
          title: "มีแผนเมื่อโทรศัพท์ใช้ไม่ได้",
          text: "เขียนเบอร์สำคัญ จุดนัดพบ และข้อมูลยาลงกระดาษ ตกลงเวลาส่งข้อความหรือกลับมาติดต่อใหม่ และมีผู้ติดต่อกลางที่อยู่นอกย่านเมื่อเหมาะกับครอบครัว",
        },
        {
          title: "ประหยัดแบตและเลือกช่องทางสำรอง",
          text: "ส่งข้อความสั้นแทนการโทรซ้ำเมื่อเครือข่ายแน่น ชาร์จพาวเวอร์แบงก์ และฟังวิทยุใช้ถ่านหรือหมุนมือหากมี โดยจดช่องทางข่าวที่เชื่อถือได้ไว้ก่อน",
        },
        {
          title: "ยึดประกาศที่ยืนยันได้",
          text: "ตรวจประกาศจากหน่วยงานท้องถิ่น ผู้ดูแลอาคาร โรงเรียน หรือนายจ้างก่อนเดินทาง อพยพ หรือให้อยู่ในที่ปลอดภัย อย่าส่งต่อข่าวจากโพสต์ที่ตรวจแหล่งที่มาไม่ได้",
        },
        {
          title: "ดูแลคนที่ต้องการความช่วยเหลือก่อน",
          text: "ตรวจยา อุปกรณ์แพทย์ เด็ก ผู้สูงอายุ ผู้พิการ และสัตว์เลี้ยงเป็นส่วนหนึ่งของแผน หากต้องใช้ไฟฟ้าหรือการเคลื่อนย้ายเฉพาะทาง ให้หาความช่วยเหลือล่วงหน้าเมื่อทำได้",
        },
      ],
      boundary:
        "หากมีอันตรายเฉพาะหน้า ให้เลือกที่ปลอดภัยก่อนและทำตามคำสั่งทางการในพื้นที่ แผนส่วนตัวไม่แทนคำสั่งอพยพ การหลบอยู่กับที่ หรือการช่วยเหลือฉุกเฉินของเจ้าหน้าที่",
    },
    situations: [
      {
        title: "วันทำงานและวันเรียน",
        text: "วางแผนว่าใครรับเด็กได้ ใครมีข้อมูลโรงเรียนหรือนายจ้าง และจะสื่อสารอย่างไรหากโทรศัพท์โทรออกไม่ได้",
      },
      {
        title: "ผู้ใช้ยาและอุปกรณ์แพทย์",
        text: "บันทึกยาประจำ ความต้องการไฟฟ้าหรือการเคลื่อนย้าย และติดต่อแหล่งช่วยเหลือล่วงหน้าตามความจำเป็น",
      },
      {
        title: "ข้อมูลส่วนตัว",
        text: "เก็บสำเนาเข้ารหัสและให้เฉพาะคนที่จำเป็นเข้าถึง ไม่ส่งรหัสผ่านหรือรายละเอียดสุขภาพในกลุ่มสาธารณะ",
      },
    ],
    checklist: [
      "ตกลงผู้ติดต่อและจุดนัดพบ",
      "บันทึกความต้องการเฉพาะคนและสัตว์",
      "แจกสำเนาแผนให้คนในบ้าน",
      "ฝึกแผนและอัปเดตเมื่อข้อมูลเปลี่ยน",
      "สำรองแผนแบบเข้ารหัส",
      "วางแผนสำหรับเวลางานและเวลาเรียน",
      "กำหนดผู้รับผิดชอบยา เอกสาร และสัตว์เลี้ยง",
    ],
  },
  en: {
    notice: [
      "An emergency can separate household members, disrupt phones, or prevent a return home.",
      "Children, older adults, disabled people, medicine users, and pets may need individual arrangements.",
      "A plan people do not know, or one with outdated contacts, may fail when it is needed.",
      "Work, school, travel, and caregiving can place household members apart, so make a daytime plan as well as a home plan.",
    ],
    prepare: [
      "Record contacts, meeting points, regular medicines, pet details, and each person's needs.",
      "Export an encrypted backup and keep its passphrase separately from the device.",
      "Choose meeting places at home, nearby, and outside the neighbourhood, plus an out-of-area contact.",
      "Keep a portable copy of essential information and agree who can take medicines, documents, or pet supplies, based on each person's real ability.",
    ],
    during: [
      "Use the agreed plan and adapt it to local authority instructions.",
      "Use short messages when networks are congested and conserve battery power.",
      "Send a short status, location, and meeting-point update, then wait instead of repeatedly calling.",
      "Use the latest confirmed information from a school, employer, building manager, or local authority before changing travel or meeting plans.",
    ],
    avoid: [
      "Do not keep the only copy of essential information on one phone.",
      "Do not place sensitive details in the unprotected quick section of the plan.",
      "Do not choose a meeting place in a hazard area or travel against an instruction to shelter in place.",
      "Do not post passphrases, medical details, or household addresses in a public chat, even while trying to find one another.",
    ],
    help: [
      "Use the contact directory to find the service appropriate to the incident and area.",
      "If someone is missing, give authorities the latest confirmed information.",
      "Arrange help in advance when someone relies on powered medical equipment, assisted transport, or does not have a vehicle.",
      "Review the plan when a member's information or needs change, such as a move, new school, or new medicine, rather than waiting for an emergency.",
    ],
    example:
      "A child cannot get home because roads are closed: use the backup meeting point and agreed contact, check local notices, and share a short location update privately.",
    emergencyKit: {
      intro:
        "Start with everyday items your household will genuinely use, and build the kit gradually during regular shopping. You do not need to buy everything at once or stockpile more than you need.",
      target:
        "Use a three-day household baseline that fits your location and actual needs. Three litres of drinking water per person per day is one UK Government example for drinking only; cooking, hygiene, heat, children, and health needs can change the amount.",
      items: [
        {
          title: "Drinking water and long-life food",
          text: "Keep bottled drinking water and food you would normally eat that needs no refrigeration or complex cooking, such as tinned food, dried food, rice, or snacks. Include a tin opener when needed.",
        },
        {
          title: "Light and backup power",
          text: "Keep a torch, spare batteries, power bank, and cables that fit your household devices. A torch is safer than candles during a power cut.",
        },
        {
          title: "Communication and information",
          text: "Write down essential numbers, meeting points, and radio frequencies on paper. Consider a battery or wind-up radio, whistle, and a map where these suit your area.",
        },
        {
          title: "Hygiene",
          text: "Prepare toilet paper, wet wipes, hand sanitiser, masks, rubbish bags, and the bathroom items your household actually uses. Emergencies do not remove hygiene needs.",
        },
        {
          title: "Medicine and first aid",
          text: "Keep regular medicine, a medicine list, allergy information, and a usable first-aid kit. Review labels, expiry dates, and storage directions regularly.",
        },
        {
          title: "Clothing and daily-living items",
          text: "Choose blankets, rainwear, walkable shoes, and cooking items based on your household risks. Do not rely on fuel-burning equipment in an enclosed space.",
        },
        {
          title: "A grab bag",
          text: "Keep take-away essentials together: copies of documents, keys, an appropriate amount of cash, water, food, medicines, and contact information. Store it where the responsible person can reach it.",
        },
        {
          title: "Individual and pet needs",
          text: "Add formula, food, nappies, mobility aids, medicines, or pet food according to the people and animals in your household, and agree who takes what if you must leave.",
        },
      ],
      rotation:
        "Set a reminder to check it at least every six months. Use items before they expire, then replace them through normal shopping. Being prepared helps during the first disruption without taking essentials away from others.",
    },
    serviceDisruption: {
      intro:
        "During armed conflict or war, civilians may experience disruption to power, water, travel, or communications. This plan helps a household wait for information and assistance in an organised way; it does not predict what kind of event will happen.",
      actions: [
        {
          title: "Plan for a phone that does not work",
          text: "Write essential numbers, meeting points, and medicine information on paper. Agree when to send a message or try again, and use an out-of-area contact if that suits your household.",
        },
        {
          title: "Save battery and use a backup channel",
          text: "Use short texts instead of repeated calls on a congested network. Keep a power bank charged and use a battery or wind-up radio if available; write down trusted news channels in advance.",
        },
        {
          title: "Act on verified instructions",
          text: "Check notices from local authorities, a building manager, school, or employer before travelling, evacuating, or sheltering. Do not pass on a post whose source cannot be verified.",
        },
        {
          title: "Check people who need extra support first",
          text: "Include medicines, medical equipment, children, older adults, disabled people, and pets in the plan. Arrange help ahead where possible if someone needs power or assisted transport.",
        },
      ],
      boundary:
        "If there is immediate danger, get to safety first and follow official local instructions. A household plan never replaces an evacuation order, a shelter-in-place instruction, or emergency help from responders.",
    },
    situations: [
      {
        title: "Work and school day",
        text: "Decide who can collect a child, who has school or employer details, and how you will communicate if phone calls fail.",
      },
      {
        title: "Medicines and medical equipment",
        text: "Record regular medicines, power or mobility needs, and arrange assistance in advance where appropriate.",
      },
      {
        title: "Private information",
        text: "Keep an encrypted copy and give access only to people who need it. Do not send passphrases or health details in a public group.",
      },
    ],
    checklist: [
      "Agree on contacts and meeting points",
      "Record individual and pet needs",
      "Give household members a copy",
      "Practise and update the plan",
      "Keep an encrypted backup",
      "Plan for work and school hours",
      "Assign medicines, documents, and pet supplies",
    ],
  },
};
